import React, { useEffect, useRef, useState } from "react";
// import Practitoner from "./practitoner";
// import Footer from "../../footer";
// import Search from "../../../../../components/search";
import "./practitoner/practitoner.css";
import "../practitonerInfo/practitonerinfo.css";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Prepaypostpaycheck from "./subcomponents/prepaypostpaycheck";
import {
  setPaymentMethodAvailbale,
  setPaymentTypeAvailbale,
} from "../../../../../reducer/clientsSlice";
import { useOutsideAlerter } from "../../../../../utils/helpers";
import { ScrollController } from "@fullcalendar/core/internal";
import { getMediumServiceDetails } from "../../../../../services/client";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function PractitionersMain({
  specialtyData = [],
  languages = [],
  practitioners = [],
  onClick,
  back,
  getPractitionarFiltersList,
  setBookInfo,
  startBookaSessionLaterVideo,
  startBookaSessionLaterQuestions,
  getSubsessions,
  setRenderType
}) {
  const { t } = useTranslation("clientPremium");
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.user);
  const wrapperRef = useRef(null);

  const [languagesList, setlanguagesList] = useState([]);
  const [specialtyList, setspecialtyList] = useState([]);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const [maxNoOfParticipantList, setMaxNoOfParticipantList] = useState([
    {
      id: 1,
      name: "1",
      status: false,
      label: "1",
      type: "maxNoOfParticipant",
    },
    {
      id: 2,
      name: "2",
      status: false,
      label: "2",
      type: "maxNoOfParticipant",
    },
  ]);
  const [currencyList, setCurrencyList] = useState([
    {
      id: 1,
      name: "AUD",
      status: false,
      label: "AUD",
      type: "currency",
    },
    {
      id: 2,
      name: "CAD",
      status: false,
      label: "CAD",
      type: "currency",
    },
    {
      id: 3,
      name: "USD",
      status: false,
      label: "USD",
      type: "currency",
    },
  ]);
  const [sessionLengthList, setsessionLengthList] = useState([
    {
      id: 30,
      name: "30Minutes",
      status: false,
      label: "30 Minutes",
      type: "sessionlength",
    },
    {
      id: 45,
      name: "45Minutes",
      status: false,
      label: "45 Minutes",
      type: "sessionlength",
    },
    {
      id: 60,
      name: "60Minutes",
      status: false,
      label: "60 Minutes",
      type: "sessionlength",
    },
    {
      id: 452,
      name: "452Minutes",
      status: false,
      label: "45 Minutes for 2 People",
      type: "sessionlength",
    },
    {
      id: 602,
      name: "602Minutes",
      status: false,
      label: "60 Minutes for 2 People",
      type: "sessionlength",
    },
  ]);
  const [experienceList, setExperienceList] = useState([
    {
      id: 1,
      name: "1year",
      status: false,
      label: "1 year",
      type: "experience",
    },
    {
      id: 2,
      name: "2years",
      status: false,
      label: "2-3 years",
      type: "experience",
    },
    {
      id: 3,
      name: "3years",
      status: false,
      label: "3-5 years",
      type: "experience",
    },
    {
      id: 4,
      name: "4years",
      status: false,
      label: "5-10 years",
      type: "experience",
    },
    {
      id: 5,
      name: "5years",
      status: false,
      label: "10-15 years",
      type: "experience",
    },
    {
      id: 6,
      name: "6years",
      status: false,
      label: "15+ years",
      type: "experience",
    },
  ]);
  const [whereDoIPayList, setwhereDoIPayList] = useState([
    {
      id: 1,
      name: "PaytoBook",
      status: false,
      label: "Pay to Book",
      type: "whereDoI",
    },
    {
      id: 2,
      name: "PayAfterSession",
      status: false,
      label: "Pay After Session",
      type: "whereDoI",
    },
  ]);
  const [recording, setRecording] = useState("");
  const [currencyName, setCurrencyName] = useState("");
  const [selectedName, setSelectedName] = useState("");
  const [paytypeText, setPaytypeText] = useState("");

  const [filterData, setFilterData] = useState({
    selectedName: "",
    languages: [],
    specialities: [],
    allow_REcording: "",
    whereDoIPay: [],
    sessionLength: [],
    experience: [],
    session_currency: "",
  });
  const [displayData, setDisplayData] = useState({
    selectedName: "",
    languages: [],
    specialities: [],
    allow_REcording: "",
    whereDoIPay: [],
    sessionLength: [],
    experience: [],
    session_currency: "",
  });
  const [offset, setOffset] = useState(0);

  const [professionalInfo, setProfessionalInfo] = useState();
  const [filterTab, setFilterTab] = useState(true);

  const [mediumSessionInfo, setMediumSessionInfo] = useState();
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    let off = localStorage.getItem("offset");
    if (off !== undefined) {
      window.scrollTo({ top: off, left: 0, behavior: "smooth" });
    }

    const onScroll = () => setOffset(window.pageYOffset);
    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const updateLanguage = (value, checked) => {
    let list = languagesList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setlanguagesList(list);
  };

  const updateSpeciality = (value, checked) => {
    let list = specialtyList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setspecialtyList(list);
  };
  const updateSessionLength = (value, checked) => {
    let list = sessionLengthList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setsessionLengthList(list);
  };
  const updateExperience = (value, checked) => {
    let list = experienceList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setExperienceList(list);
  };
  const updatewhereDoIPay = (value, checked) => {
    let list = whereDoIPayList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setwhereDoIPayList(list);
  };
  const updateCurrency = (value, checked) => {
    let list = currencyList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setCurrencyList(list);
  };
  const updateMaxNoOfParticipant = (value, checked) => {
    let list = maxNoOfParticipantList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setMaxNoOfParticipantList(list);
  };
  const deleteElement = async (item, type) => {
    let info = filterData;
    if (type === "language") {
      removeValue(info.languages, String(item.id));
      updateLanguage(item.id, false);
    }
    if (type === "sessionlength") {
      removeValue(info.sessionLength, item.id);
      updateSessionLength(item.id, false);
    }
    if (type === "experience") {
      removeValue(info.experience, String(item.id));
      updateExperience(item.id, false);
    }
    if (type === "wheredoipay") {
      removeValue(info.whereDoIPay, String(item.id));
      updatewhereDoIPay(item.id, false);
    } else {
      removeValue(info.specialities, String(item.id));
      updateSpeciality(item.id, false);
    }
    if (type === "currency") {
      removeValue(info.sessionLength, item.id);
      updateMaxNoOfParticipant(item.id, false);
    }
    setFilterData(info);
    getPractitionarFiltersList(info);
  };

  const deleteInfo = (type) => {
    let info = filterData;
    if (type === "rec") {
      info.allow_REcording = "";
    } else if (type === "curren") {
      info.session_currency = "";
    } else {
      info.whereDoIPay = "";
    }
    setFilterData(info);
    getPractitionarFiltersList(info);
  };
  const changeHandler = (e, type) => {
    let checked = e.target.checked;
    let value = e.target.value;
    let name = e.target.name;
    clearTimeout(timer);

    let info = filterData;
    let display = displayData;

    if (type === "name") {
      if (value) {
        setSelectedName(value);
        info.selectedName = value;
      } else {
        info.selectedName = "";
        setSelectedName("");
      }
    }
    if (type === "maxNoOfParticipant") {
      updateMaxNoOfParticipant(value, checked);
      sessionLengthList.map((item) => {
        updateSessionLength(item.id, false);
      });
      if (checked) {
        let lens = maxNoOfParticipantList.every((item) => item.status);
        if (maxNoOfParticipantList.every((item) => item.status)) {
          info.sessionLength = [];
          info.sessionLength.push(30, 45, 60, 452, 602);
        } else if (value == 1) {
          info.sessionLength = [];
          info.sessionLength.push(30, 45, 60);
        } else {
          info.sessionLength = [];
          info.sessionLength.push(452, 602);
        }
        display.sessionLength.push(name);
      } else {
        if (value == 1) {
          removeValue(info.sessionLength, 30);
          removeValue(info.sessionLength, 45);
          removeValue(info.sessionLength, 60);
        } else {
          removeValue(info.sessionLength, 452);
          removeValue(info.sessionLength, 602);
        }
        removeValue(info.sessionLength, value);
        // removeValue(display.sessionLength, name);
      }
    }
    if (type === "language") {
      updateLanguage(value, checked);
      if (checked) {
        info.languages.push(value);
        display.languages.push(name);
      } else {
        removeValue(info.languages, value);
        removeValue(display.languages, name);
      }
    }
    if (type === "specialty") {
      updateSpeciality(value, checked);
      if (checked) {
        info.specialities.push(value);
        display.specialities.push(name);
      } else {
        removeValue(info.specialities, value);
        removeValue(display.specialities, name);
      }
    }
    if (type === "Recording") {
      if (checked) {
        setRecording(name);
        info.allow_REcording = value;
      } else {
        info.allow_REcording = "";
        setRecording("");
      }
      // if (checked) {
      //   info.allow_REcording.push(value);
      //   display.allow_REcording.push(name);
      // } else {
      //   removeValue(info.allow_REcording, value);
      //   removeValue(display.allow_REcording, name);
      // }
    }
    if (type === "currency") {
      if (checked) {
        setCurrencyName(name);
        info.session_currency = name;
      } else {
        info.session_currency = "";
        setCurrencyName("");
      }
    }
    // if (type === "wheredoipay") {
    //   if (checked && name === "when_do_i_pay_1") {
    //     info.whereDoIPay = 1;
    //     setPayTime("Pay to Book");
    //   } else if (checked && name === "when_do_i_pay_2") {
    //     setPayTime("Pay After Session");
    //     info.whereDoIPay = 2;
    //   } else {
    //     setPayTime("");
    //     info.whereDoIPay = "";
    //   }
    //   // if (checked) {
    //   //   info.whereDoIPay.push(value);
    //   //   display.whereDoIPay.push(name);
    //   // } else {
    //   //   removeValue(info.whereDoIPay, value);
    //   //   removeValue(display.whereDoIPay, name);
    //   // }
    // }
    if (type === "wheredoipay") {
      updatewhereDoIPay(value, checked);
      if (checked) {
        info.whereDoIPay.push(value);
        display.whereDoIPay.push(name);
      } else {
        removeValue(info.whereDoIPay, value);
        removeValue(display.whereDoIPay, name);
      }
    }

    if (type === "sessionlength") {
      updateSessionLength(value, checked);
      maxNoOfParticipantList.map((item) => {
        updateMaxNoOfParticipant(item.id, false);
      });

      if (checked) {
        info.sessionLength = [];
        let itesm = [];
        sessionLengthList.map((item) => {
          if (item.status) {
            itesm.push(item.id);
          }
        });
        itesm.map((val) => {
          info.sessionLength.push(val);
        });
        // display.sessionLength.push(name);
      } else {
        removeValue(info.sessionLength, parseInt(value));
        removeValue(display.sessionLength, name);
      }
    }
    if (type === "experience") {
      updateExperience(value, checked);
      if (checked) {
        info.experience.push(value);
        display.experience.push(name);
      } else {
        removeValue(info.experience, value);
        removeValue(display.experience, name);
      }
    }
    const newTimer = setTimeout(() => {

      getPractitionarFiltersList(info);
    }, 500);
    setTimer(newTimer);
    setDisplayData(display);
    setFilterData(info);
  };





  useEffect(() => {
    let states = checkWindowSize() > 767 ? true : false;

    setFilterTab(states);
  }, []);
  useEffect(() => {
    // window.loadModal2('#Prepaypostpaycheck', 'show');

    let items = languages.map((item) => {
      return {
        ...item,
        status: false,
        type: "languages",
      };
    });
    setlanguagesList(items);
  }, ["", languages]);
  useEffect(() => {
    let items = specialtyData.map((item) => {
      return {
        ...item,
        status: false,
        type: "specialty",
      };
    });
    setspecialtyList(items);
  }, ["", specialtyData]);
  const removeValue = (array, value) => {
    const index = array.indexOf(value);
    if (index > -1) {
      array.splice(index, 1);
    }
    return array;
  };
  const getBookingLink = (info) => {
    console.log("info", info);
   
    localStorage.setItem("offset", offset);
   
    setProfessionalInfo(info);
    if (info.show_flexbooker) {
      startSeesion(info);
    } else {
      //live start
      // if (checkPostPreType(info)) {
      //live end
      // startSeesion(info);
      getMediumServiceDetails(info.medium_id)
        .then((data) => {
          if (data.data.status) {
            setMediumSessionInfo(data.data.data[0]);
            window.loadModal2("#Prepaypostpaycheck", "show");
          }
        })
        .catch(() => { });
      // }
    }
  };

  const startSeesionNew = (info) => {
    let inf = {
      general: {
        ...info,
        personal_booking_link: info.personal_booking_link,
        payType: info.payType,
        pre_pay_session_type: info.pre_pay_session_type,
        post_pay_session_type: info.post_pay_session_type,
        medium_id: info.medium_id,
        
      },
    };
    console.log("inf", inf);
    setBookInfo(inf);
    {
      setRenderType("newappointment");
      // auth.user.terms_session_status === 1
      //   ? startBookaSessionLaterQuestions()
      //   : startBookaSessionLaterVideo();
    }
  };
  const startSeesion = (info) => {
    let inf = {
      general: {
        personal_booking_link: info.personal_booking_link,
        payType: info.payType,
        pre_pay_session_type: info.pre_pay_session_type,
        post_pay_session_type: info.post_pay_session_type,
        medium_id: info.medium_id,
        ...info,
      },
    };
    console.log("pala", inf);
    setBookInfo(inf);
    {
      setRenderType("newappointment");
      // auth.user.terms_session_status === 1
      //   ? startBookaSessionLaterQuestions()
      //   : startBookaSessionLaterVideo();
    }
  };
  const checkPostPreType = (info) => {
    let status = false;
    const {
      payType,
      post_pay_schedule,
      pre_pay_schedule,
      is_paypal_integrated,
      is_stripe_integrated,
    } = info;

    if (!is_paypal_integrated && !is_stripe_integrated) {
      toast.error(t("listing.noAvailability"), {
        position: "top-center",
      });
      return;
    } else if (is_paypal_integrated && is_stripe_integrated) {
      dispatch(setPaymentMethodAvailbale("both"));
    } else if (is_paypal_integrated && !is_stripe_integrated) {
      dispatch(setPaymentMethodAvailbale("paypal"));
    } else if (!is_paypal_integrated && is_stripe_integrated) {
      dispatch(setPaymentMethodAvailbale("stripe"));
    }

    if (payType.length === 2) {
      if (!post_pay_schedule && !pre_pay_schedule) {
        // setPaytypeText('both post pay pre pay avialable for this medium')
        toast.error(t("listing.noAvailability"), {
          position: "top-center",
        });
        return;
      }
      if (post_pay_schedule && pre_pay_schedule) {
        // window.loadModal2("#Prepaypostpaycheck", "show");
        // setPaytypeText('both post pay pre pay avialable for this medium')
        // toast.success('both post pay pre pay avialable for this medium', { position: 'top-center' })
        // status = true
      } else if (post_pay_schedule && !pre_pay_schedule) {
        // window.loadModal2("#Prepaypostpaycheck", "show");
        // setPaytypeText('Only post pay avialable for this medium')
        dispatch(setPaymentTypeAvailbale("Pay After Session"));
        // status = true;
        // toast.error('Only post pay avialable for this medium', { position: 'top-center' })
      } else if (!post_pay_schedule && pre_pay_schedule) {
        // window.loadModal2("#Prepaypostpaycheck", "show");
        dispatch(setPaymentTypeAvailbale("Pay Before Session"));

        // status = true;
        // setPaytypeText('Only pre pay avialable for this medium')
        // toast.error('Only pre pay avialable for this medium', { position: 'top-center' })
      }

      // else if (post_pay_schedule || pre_pay_schedule) {
      //   status = true
      // }
      else {
        // setPaytypeText('No schedule available for this medium')
        toast.error(t("listing.noSchedule"), {
          position: "top-center",
        });
      }
    } else {
      if (payType[0] === 1 && pre_pay_schedule) {
        dispatch(setPaymentTypeAvailbale("Pay Before Session"));
        // getSubsessions(8);
        // setPaytypeText('only pre pay added and available')
        // toast.success('only pre pay added and available', { position: 'top-center' })
        status = true;
      }
      // else if (payType[0] === 1 && !pre_pay_schedule) {
      //   setPaytypeText('No pre pay schedule available for this medium')
      //   toast.error('No pre pay schedule available for this medium', { position: 'top-center' })
      // }
      else if (payType[0] === 2 && post_pay_schedule) {
        dispatch(setPaymentTypeAvailbale("Pay After Session"));
        // getSubsessions(7);
        // setPaytypeText('only post pay added and available')
        // toast.success('only post pay added and available', { position: 'top-center' })
        status = true;
      }
      // else if (payType[0] === 2 && !post_pay_schedule) {
      //   setPaytypeText('No post pay schedule available for this medium')
      //   toast.error('No post pay schedule available for this medium', { position: 'top-center' })
      // }
      else {
        // setPaytypeText('No schedule available for this medium')
        toast.error(t("listing.noAvailability"), {
          position: "top-center",
        });
      }
    }
    return status;
  };
  // const filterListMediums = (constants) => {
  //   const { email, screen_name, created_at, orderBy = "asc" } = constants;
  //   let body = {
  //     email,
  //     screen_name,
  //     created_at,
  //     orderBy,
  //   };

  //     filterAllmediums(body)
  //       .then((data) => {
  //         if (data.data.status) {
  //           dispatch(setAllMediums(data.data.data.data));
  //           setbackupMediums(JSON.parse(JSON.stringify(data.data.data.data)));
  //         }
  //       })
  //       .catch(() => {});

  // };

  const checkWindowSize = () => {
    return window.innerWidth;
  };
  const clickViewProfile = (item) => {
    localStorage.setItem("offset", offset);
    onClick(item.id);
  };
  const backbtnHandler = () => {
    localStorage.removeItem("offset");
    back();
  };
  const scrollControllerHandler = () => {
    window.scrollTo({ top: offset + 200, left: 0, behavior: "smooth" });
  };
  const checkSessionExtraPersion = (item) => {
    const obj = JSON.parse(item.session_length);

    const sessionKeys = Object.keys(obj);
    const isOffered = sessionKeys.includes("452") || sessionKeys.includes("602");
    if (isOffered) {
      return "";
    } else {
      return <em>{t("card.notOffered")}</em>;
    }
  }
  const checkSessionFoutyFiveExtraPersion = (item) => {
    if (Array.isArray(item.offerings)) {
      const offering = item.offerings.find((o) => o.key === "452");
      if (!offering) {
        return <em>{t("card.notOffered")}</em>;
      }
      let delta = offering.extra_person_delta;
      if (delta === null || delta === undefined || delta === "") {
        delta =
          offering.base_price !== null && offering.base_price !== undefined && offering.base_price !== ""
            ? parseFloat(offering.price) - parseFloat(offering.base_price)
            : offering.price;
      }
      return "$ " + delta + " " + offering.currency;
    }

    // Fallback for API responses without the `offerings` array yet
    const session_currency_obj = JSON.parse(item.session_currency);
    const obj = JSON.parse(item.session_length);
    const sessionCurrencyKeys = Object.keys(session_currency_obj);
    const sessionKeys = Object.keys(obj);
    const isOffered = sessionKeys.includes("452");
    const sessionCurrency = sessionCurrencyKeys.includes("452");
    let currency = "USD";
    if (sessionCurrency) {
      currency = session_currency_obj[452];
    }
    if (isOffered) {
      return "$ " + obj[452] + " " + currency;
    } else {
      return <em>{t("card.notOffered")}</em>;
    }
  }
  const checkSessionSixtyExtraPersion = (item) => {
    if (Array.isArray(item.offerings)) {
      const offering = item.offerings.find((o) => o.key === "602");
      if (!offering) {
        return <em>{t("card.notOffered")}</em>;
      }
      let delta = offering.extra_person_delta;
      if (delta === null || delta === undefined || delta === "") {
        delta =
          offering.base_price !== null && offering.base_price !== undefined && offering.base_price !== ""
            ? parseFloat(offering.price) - parseFloat(offering.base_price)
            : offering.price;
      }
      return "$ " + delta + " " + offering.currency;
    }

    // Fallback for API responses without the `offerings` array yet
    const session_currency_obj = JSON.parse(item.session_currency);
    const obj = JSON.parse(item.session_length);
    const sessionCurrencyKeys = Object.keys(session_currency_obj);
    const sessionKeys = Object.keys(obj);
    const isOffered = sessionKeys.includes("602");
    const sessionCurrency = sessionCurrencyKeys.includes("602");
    let currency = "USD";
    if (sessionCurrency) {
      currency = session_currency_obj[602];
    }
    if (isOffered) {
      return "$ " + obj[602] + " " + currency;
    } else {
      return <em>{t("card.notOffered")}</em>;
    }
  }

  const checkSessionOffered = (item) => {

    if (item.session_length !== "" && item.length !== undefined) {
      if (
        ((JSON.parse(item.session_length))[4] === undefined ||
          Object.values(JSON.parse(item.session_length))[4] === "") &&
        ((JSON.parse(item.session_length))[3] === "" ||
          Object.values(JSON.parse(item.session_length))[3] === undefined)
      ) {
        return <em>{t("card.notOffered")}</em>;
      }
      // (Object.values(
      //   JSON.parse(item.session_length)
      // )[4] === "" ||
      //   Object.values(
      //     JSON.parse(item.session_length)
      //   )[4] === undefined) &&
      // (Object.values(
      //   JSON.parse(item.session_length)
      // )[3] === "" || Object.values(
      //   JSON.parse(item.session_length)
      // )[3] === undefined) && (
      //   <em>Not Offered</em>
      // )
    } else {
      return <em>{t("card.notOffered")}</em>;
    }
  };
  const checkItemFortyFive = (item) => {
    if (item.session_length !== "" && item.session_length !== undefined) {
      if (
        Object.values(JSON.parse(item.session_length))[3] === "" ||
        Object.values(JSON.parse(item.session_length))[3] === undefined
      ) {
        return true;
      }
    } else {
      return true;
    }
  };
  const isfourtyFive = (item) => {
    if (item.session_length !== "" && item.session_length !== undefined) {
      const obj = JSON.parse(item.session_length);
      const sessionKeys = Object.keys(obj);
      const isOffered = sessionKeys.includes("452");
      if (!isOffered) {
        return true;
      }
    } else {
      return true;
    }
  }
  const isSixtyForTwo = (item) => {
    if (item.session_length !== "" && item.session_length !== undefined) {
      const obj = JSON.parse(item.session_length);
      const sessionKeys = Object.keys(obj);
      const isOffered = sessionKeys.includes("602");
      if (!isOffered) {
        return true;
      }
    } else {
      return true;
    }
  }
  const fourtyFive = (item) => {
    if (item.session_length !== "" && item.session_length !== undefined) {
      if (
        Object.values(JSON.parse(item.session_length))[3] === "" ||
        Object.values(JSON.parse(item.session_length))[3] === undefined
      ) {
        return true;
      }
    } else {
      return true;
    }
  };
  const checkItemSixty = (item) => {
    if (item.session_length !== "" && item.session_length !== undefined) {
      if (
        Object.values(JSON.parse(item.session_length))[4] === "" ||
        Object.values(JSON.parse(item.session_length))[4] === undefined
      ) {
        return true;
      }
    } else {
      return true;
    }
  };
  checkWindowSize() < 767 && useOutsideAlerter(wrapperRef, setFilterTab);

  const add3Dots = (string, limit) => {
    var dots = "...";
    if (string.length > limit) {
      // you can also use substr instead of substring
      string = string.substring(0, limit) + dots;
    }

    return string;
  }

    useEffect(() => {
    const params = new URLSearchParams(location.search);
    const from = params.get("from");
    const mediumId = params.get("selectedMediumId");

    if (from === "coach-reviews") {
        console.log("MATCHED MEDIUM DATA");
        let infodetaiol = JSON.parse(sessionStorage.getItem("userDataInfo"));
        setProfessionalInfo(infodetaiol);
        getMediumServiceDetails(infodetaiol.medium_id)
          .then((data) => {
            if (data.data.status) {
              setMediumSessionInfo(data.data.data[0]);
              let singleVal = data.data.data[0];
                  const sessionType = singleVal.type;
                  const durationValue = singleVal.info[0].subsession_id;
                  const durationVal = singleVal.info[0].forTwo != 0 ? singleVal.info[0].duration+"2" : singleVal.info[0].duration;
                  const amountVal = singleVal.info[0].price;
                  const currencyVal = singleVal.info[0].currency;
                  const info  = singleVal.info;
                  

                  // Get first record from info
                  const firstInfo = singleVal.info[0];
                  let updatedPayment = {
                    ...infodetaiol,
                    subsession_id: firstInfo.subsession_id,
                    payStatus: sessionType === "Pay_Before" ? 'before' : 'after'
                  };

                  // ✅ Update State
                  //setProfessionalInfo(updatedPayment);

                  
                  //startSeesion(paymen);
                 
                  getSubsessions(info, durationValue, durationVal ,amountVal,currencyVal)
                  console.log(info,durationValue,durationVal,amountVal,currencyVal,"value");
                  // ✅ Now Call the Function
                  startSeesionNew(updatedPayment);
            }
          })
          .catch(() => { });

    }
  }, [location.search, practitioners]);
  return (
    <>
      

      {/* <div>
        <h4 className="practioner-heading">Practitioner</h4>
        <div className="starter-practioners">
          <div className="container">
            <div className="row box-practioners-internal">
              {practitioners.length &&

                practitioners.map((item) => (
                  <Practitoner item={item} onClick={onClick} />
                ))
              }

            </div>
          </div>
        </div>
        <div className="text-center">
          <Footer />
        </div>
      </div> */}
      <Prepaypostpaycheck
        mediumSessionInfo={mediumSessionInfo}
        getSubsessions={getSubsessions}
        paytypeText={paytypeText}
        startSeesion={startSeesion}
        professionalInfo={professionalInfo}
      />
    </>
  );
}
